function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const FileSpreadsheetIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.7 7.2C28 6.2 27 5.1 26 4s-2.2-2-3.1-2.7C21.2.1 20.4 0 20 0H4.5C3.1 0 2 1.1 2 2.5v27C2 30.9 3.1 32 4.5 32h23c1.4 0 2.5-1.1 2.5-2.5V10c0-.4-.1-1.2-1.3-2.8zm-4.2-1.7c1 1 1.7 1.8 2.3 2.5H22V3.2c.7.5 1.6 1.3 2.5 2.3zm3.5 24c0 .3-.2.5-.5.5h-23c-.3 0-.5-.2-.5-.5v-27c0-.3.2-.5.5-.5H20v7c0 .6.4 1 1 1h7v19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12v15h17.2V12H7.5zm6.4 9.6v-3.2h4.3v3.2h-4.3zm4.3 1.1v3.2h-4.3v-3.2h4.3zm0-8.6v3.2h-4.3v-3.2h4.3zm-5.3 0v3.2H8.6v-3.2h4.3zm-4.3 4.3h4.3v3.2H8.6v-3.2zm10.7 0h4.3v3.2h-4.3v-3.2zm0-1.1v-3.2h4.3v3.2h-4.3zM8.6 22.7h4.3v3.2H8.6v-3.2zm10.7 3.2v-3.2h4.3v3.2h-4.3z"
  }));
};
export default FileSpreadsheetIcon;